//
// Tabbed Demo Manager
// Like the demo manager. But with tabs and colours
//

// Here's the parameters you can pass in json
//  buttonWidth/ buttonHeight - the width and height of a button
//  spacing - the space between buttons
//  activeTabColour - the colour of the currently active tab
//  inactiveTabColour- the colour of the other tabs
//  tabWidth / tabHeight - the width and height of a single tab
//  buttonBackgroundColour - the colour of the background behind the buttons
//  json.buttonColour - the colour of the buttons. Will automatically calculate highlight and lowlight colour
//  tabTextSize - the size of text on the tabs
//  buttonTextSize - the size of text on the buttons

tabbedDemoManager = {};
tabbedDemoManager.TAB_WIDTH = 200; // This is the width at the tabs at the top
tabbedDemoManager.TAB_HEIGHT = 40;
tabbedDemoManager.BUTTON_WIDTH = 200; // This the width of the buttons
tabbedDemoManager.BUTTON_HEIGHT = 50;
tabbedDemoManager.SPACING = 20; // This is the spacing between buttons
tabbedDemoManager.TRI_WIDTH = 120; // This is the width of the triangle demo button
tabbedDemoManager.TRI_HEIGHT = 120;
tabbedDemoManager.COLUMNS = 4; // This is how many button columns in the popup window
tabbedDemoManager.activeTabColour = '0x00FF00';
tabbedDemoManager.inactiveTabColour = '0x007700';
tabbedDemoManager.tabTextSize = 28;
tabbedDemoManager.buttonTextSize = 22;
tabbedDemoManager.buttonBackgroundColour = '0x222222';
tabbedDemoManager.buttonColour = 0x999999;
tabbedDemoManager.buttonHighlightColour = '0xBBBBBB';
tabbedDemoManager.buttonLowlightColour = '0x333333';

tabbedDemoManager.tabTopWidth = 0;
tabbedDemoManager.buttonBackWidth = 0;

tabbedDemoManager.popupWidth = 0;
tabbedDemoManager.popupHeight = 0;
tabbedDemoManager.buttons = {};
tabbedDemoManager.persistForce = false;
tabbedDemoManager.persistedForceData = null;
tabbedDemoManager.forceQueue = [];
tabbedDemoManager.queueButtons = [];
tabbedDemoManager.queueForceAppliedOnClose = false;
tabbedDemoManager.overrideStake = false;

tabbedDemoManager.create = function (json) {
  tabbedDemoManager.tabs = [];
  return new PIXI.Graphics();
};

tabbedDemoManager.initialise = function (json, graphics) {
  if (!gdk.hasForceOptions()) return;
  tabbedDemoManager.graphics = graphics;
  tabbedDemoManager.graphics.visible = false;

  if (checkForDefined(json.columns)) tabbedDemoManager.COLUMNS = json.columns;
  if (checkForDefined(json.triSize)) tabbedDemoManager.TRI_WIDTH = tabbedDemoManager.TRI_HEIGHT = json.triSize;
  if (checkForDefined(json.buttonWidth)) tabbedDemoManager.BUTTON_WIDTH = json.buttonWidth;
  if (checkForDefined(json.buttonHeight)) tabbedDemoManager.BUTTON_HEIGHT = json.buttonHeight;
  if (checkForDefined(json.spacing)) tabbedDemoManager.SPACING = json.spacing;
  if (checkForDefined(json.activeTabColour)) tabbedDemoManager.activeTabColour = json.activeTabColour;
  if (checkForDefined(json.inactiveTabColour)) tabbedDemoManager.inactiveTabColour = json.inactiveTabColour;
  if (checkForDefined(json.tabWidth)) tabbedDemoManager.TAB_WIDTH = json.tabWidth;
  if (checkForDefined(json.tabHeight)) tabbedDemoManager.TAB_HEIGHT = json.tabHeight;
  if (checkForDefined(json.tabTextSize)) tabbedDemoManager.tabTextSize = json.tabTextSize;
  if (checkForDefined(json.buttonTextSize)) tabbedDemoManager.buttonTextSize = json.buttonTextSize;
  if (checkForDefined(json.buttonBackgroundColour))
    tabbedDemoManager.buttonBackgroundColour = json.buttonBackgroundColour;
  if (checkForDefined(json.buttonColour)) {
    tabbedDemoManager.buttonColour = json.buttonColour;
    var colour = parseInt(json.buttonColour);
    var r = (colour & 0xff0000) >> 16;
    var g = (colour & 0x00ff00) >> 8;
    var b = (colour & 0x0000ff) >> 0;
    var highColour =
      (Math.min(Math.floor(r * 1.2), 255) << 16) +
      (Math.min(Math.floor(g * 1.2), 255) << 8) +
      Math.min(Math.floor(b * 1.2), 255);
    var lowColour = (Math.floor(r * 0.8) << 16) + (Math.floor(g * 0.8) << 8) + Math.floor(b * 0.8);
    tabbedDemoManager.buttonHighlightColour = '0x' + highColour.toString(16);
    tabbedDemoManager.buttonLowlightColour = '0x' + lowColour.toString(16);
  }

  tabbedDemoManager.currentTab = 0;
  var tabsList = [];
  for (var i = 0; i < json.demos.length; i++) {
    if (json.demos[i].tab === undefined) {
      console.log('No tab defined for tabbed demo item ' + json.demos[i].name);
    } else {
      // is this cheat valid for this customer?
      let engine = gdk.getSupplierForceName(); //gdk.getEngineSupplier();
      let isSpins = json.demos[i].spins; // backwards compatibility
      let isEngine = (engine = json.demos[i][engine]);

      if (isSpins || isEngine) {
        if (tabsList.indexOf(json.demos[i].tab) === -1) {
          tabsList.push(json.demos[i].tab);
          tabbedDemoManager.createTab(json.demos[i].tab);
        }
        tabbedDemoManager.addToTab(tabsList.indexOf(json.demos[i].tab), json.demos[i]);
      }
    }
  }

  if (gdk.hasReplayForce()) {
    tabsList.push('Replay');
    tabbedDemoManager.createTab('Replay');
    tabbedDemoManager.addToTab(tabsList.indexOf('Replay'), {
      name: 'Last Game',
      all: { replayCount: 1 },
    });
    tabbedDemoManager.addToTab(tabsList.indexOf('Replay'), {
      name: 'Last 5 Games',
      all: { replayCount: 5 },
    });
  }

  // Create the "Manual" tab
  if (PIXI.TextInput) {
    var tab = tabbedDemoManager.createTab('Manual');
    tabbedDemoManager.inputText = resourceManager.createObject('textInput', 'textInput', tab.buttonContainer.name, {
      fontSize: 50,
      fill: '0xFFFFFF',
      x: 50,
      anchor: 0.5,
      y: tabbedDemoManager.TAB_HEIGHT + 100,
    });

    var sendTabbedTextButton = resourceManager.createObject('graphics', 'button', tab.buttonContainer.name, {});
    sendTabbedTextButton.interactive = true;
    sendTabbedTextButton.touchstart = sendTabbedTextButton.mousedown = function () {
      const forceData = JSON.parse(JSON.stringify(tabbedDemoManager.inputText.textInput.text));
      gdk.gameForces(forceData);

      if (tabbedDemoManager.persistForce) {
        tabbedDemoManager.persistedForceData = forceData;
      } else {
        tabbedDemoManager.persistedForceData = null;
      }

      tabbedDemoManager.close();
    };

    sendTabbedTextButton.beginFill(0x999999, 1);
    sendTabbedTextButton.drawRect(50, 300, 300, 70);
    sendTabbedTextButton.endFill();

    var buttonText = resourceManager.createObject('text', 'buttonText', sendTabbedTextButton.name, {
      fontDefinition: 'standard',
      text: 'SEND',
      anchor: 0.5,
      x: 200,
      y: 335,
    });
    buttonText.tint = 0;

    // Queue button for manual tab
    var addToQueueButton = resourceManager.createObject('graphics', 'addToQueueButton', tab.buttonContainer.name, {});
    addToQueueButton.interactive = true;
    addToQueueButton.touchstart = addToQueueButton.mousedown = function () {
      const forceData = JSON.parse(JSON.stringify(tabbedDemoManager.inputText.textInput.text));
      if (forceData && forceData.length > 0) {
        tabbedDemoManager.forceQueue.push(forceData);
        tabbedDemoManager.inputText.textInput.text = '';
        tabbedDemoManager.redraw();
      }
    };

    addToQueueButton.beginFill(0x00aa00, 1);
    addToQueueButton.drawRect(360, 300, 150, 70);
    addToQueueButton.endFill();

    var addQueueText = resourceManager.createObject('text', 'addQueueText', addToQueueButton.name, {
      fontDefinition: 'standard',
      text: 'QUEUE',
      anchor: 0.5,
      x: 435,
      y: 335,
    });
    addQueueText.tint = 0xffffff;

    // Grab from Console button for manual tab
    const grabFromConsoleButton = resourceManager.createObject(
      'graphics',
      'grabFromConsoleButton',
      tab.buttonContainer.name,
      {}
    );
    grabFromConsoleButton.interactive = true;
    grabFromConsoleButton.touchstart = grabFromConsoleButton.mousedown = function () {
      try {
        const cheatString = gdk.serverParser.getCheatString();
        let value;
        if (cheatString && typeof cheatString === 'string' && cheatString.length > 0) {
          value = cheatString;
        } else if (cheatString && typeof cheatString === 'object') {
          value = JSON.stringify(cheatString);
        } else {
          value = 'Force not found';
        }
        const textInput = tabbedDemoManager.inputText.textInput;
        textInput.htmlInput.value = value;
        textInput.htmlInput.style.display = 'block';
        setTimeout(function () {
          textInput.htmlInput.focus();
        }, 10);
      } catch (e) {
        tabbedDemoManager.inputText.textInput.text = 'Force not found';
      }
    };

    const grabBtnX = 50;
    const grabBtnY = tabbedDemoManager.TAB_HEIGHT + 170;
    const grabBtnW = 450;
    const grabBtnH = 70;

    grabFromConsoleButton.beginFill(0x0077cc, 1);
    grabFromConsoleButton.drawRect(grabBtnX, grabBtnY, grabBtnW, grabBtnH);
    grabFromConsoleButton.endFill();

    const grabFromConsoleText = resourceManager.createObject(
      'text',
      'grabFromConsoleText',
      grabFromConsoleButton.name,
      {
        fontDefinition: 'standard',
        text: 'GRAB FROM CONSOLE',
        anchor: 0.5,
        x: grabBtnX + grabBtnW / 2,
        y: grabBtnY + grabBtnH / 2,
      }
    );
    grabFromConsoleText.tint = 0xffffff;
  }

  // Persist checkbox
  tabbedDemoManager.persistCheckbox = new PIXI.Graphics();
  tabbedDemoManager.graphics.addChild(tabbedDemoManager.persistCheckbox);
  tabbedDemoManager.persistCheckbox.interactive = true;
  tabbedDemoManager.persistCheckbox.touchstart = tabbedDemoManager.persistCheckbox.mousedown =
    tabbedDemoManager.onPersistToggle;

  tabbedDemoManager.persistLabel = new PIXI.Text('Persist Force', {
    fontFamily: 'Roboto-Black',
    fontSize: 20,
    fontWeight: 'bold',
    fill: 0xffffff,
    align: 'left',
  });
  tabbedDemoManager.graphics.addChild(tabbedDemoManager.persistLabel);

  // Persist checkbox
  tabbedDemoManager.stakeOverideCheckbox = new PIXI.Graphics();
  tabbedDemoManager.graphics.addChild(tabbedDemoManager.stakeOverideCheckbox);
  tabbedDemoManager.stakeOverideCheckbox.interactive = true;
  tabbedDemoManager.stakeOverideCheckbox.touchstart = tabbedDemoManager.stakeOverideCheckbox.mousedown =
    tabbedDemoManager.onOverideStakeToggle;

  tabbedDemoManager.stakeOverideLabel = new PIXI.Text('Override Stake', {
    fontFamily: 'Roboto-Black',
    fontSize: 20,
    fontWeight: 'bold',
    fill: 0xffffff,
    align: 'left',
  });
  tabbedDemoManager.graphics.addChild(tabbedDemoManager.stakeOverideLabel);

  // Queue count text
  tabbedDemoManager.queueCountText = new PIXI.Text('Queue: 0', {
    fontFamily: 'Roboto-Black',
    fontSize: 20,
    fontWeight: 'bold',
    fill: 0xffffff,
    align: 'left',
  });
  tabbedDemoManager.graphics.addChild(tabbedDemoManager.queueCountText);

  // Clear queue button
  tabbedDemoManager.clearQueueButton = new PIXI.Graphics();
  tabbedDemoManager.graphics.addChild(tabbedDemoManager.clearQueueButton);
  tabbedDemoManager.clearQueueButton.interactive = true;
  tabbedDemoManager.clearQueueButton.touchstart = tabbedDemoManager.clearQueueButton.mousedown =
    tabbedDemoManager.clearQueue;

  tabbedDemoManager.clearQueueLabel = new PIXI.Text('Clear', {
    fontFamily: 'Roboto-Black',
    fontSize: 16,
    fontWeight: 'bold',
    fill: 0xffffff,
    align: 'center',
  });
  tabbedDemoManager.clearQueueLabel.anchor.set(0.5);
  tabbedDemoManager.graphics.addChild(tabbedDemoManager.clearQueueLabel);

  // Apply button
  tabbedDemoManager.applyButton = new PIXI.Graphics();
  tabbedDemoManager.graphics.addChild(tabbedDemoManager.applyButton);
  tabbedDemoManager.applyButton.interactive = true;
  tabbedDemoManager.applyButton.touchstart = tabbedDemoManager.applyButton.mousedown = tabbedDemoManager.close;

  tabbedDemoManager.applyLabel = new PIXI.Text('Apply Queue', {
    fontFamily: 'Roboto-Black',
    fontSize: 16,
    fontWeight: 'bold',
    fill: 0xffffff,
    align: 'center',
  });
  tabbedDemoManager.applyLabel.anchor.set(0.5);
  tabbedDemoManager.graphics.addChild(tabbedDemoManager.applyLabel);

  // This is the width of all the buttons plus spacing
  tabbedDemoManager.tabTopWidth =
    (tabbedDemoManager.SPACING + tabbedDemoManager.BUTTON_WIDTH) * tabbedDemoManager.COLUMNS +
    tabbedDemoManager.SPACING;
  // This is the width of all the tabs plus the close button
  tabbedDemoManager.buttonBackWidth = tabbedDemoManager.TAB_WIDTH * tabsList.length + tabbedDemoManager.TAB_HEIGHT;
  tabbedDemoManager.popupWidth = Math.max(tabbedDemoManager.tabTopWidth, tabbedDemoManager.buttonBackWidth);

  tabbedDemoManager.closeButton = new PIXI.Graphics();
  tabbedDemoManager.graphics.addChild(tabbedDemoManager.closeButton);
  tabbedDemoManager.closeButton.interactive = true;
  tabbedDemoManager.closeButton.touchstart = tabbedDemoManager.closeButton.mousedown = tabbedDemoManager.close;

  tabbedDemoManager.demoButtonText = new PIXI.Text('DEMO', {
    fontFamily: 'Roboto-Black',
    fontSize: 28,
    fontWeight: 'bold',
    fill: 0xffffff,
    align: 'center',
  });
  tabbedDemoManager.demoButtonText.position.set(5, 5);
  tabbedDemoManager.demoButtonText.rotation = -Math.PI * 0.25;
  tabbedDemoManager.demoButtonText.anchor.set(0.5);
  tabbedDemoManager.demoButtonText.position.set(
    tabbedDemoManager.TRI_WIDTH * 0.35,
    tabbedDemoManager.TRI_HEIGHT * 0.35
  );

  tabbedDemoManager.graphics.addChild(tabbedDemoManager.demoButtonText);

  tabbedDemoManager.graphics.touchstart = tabbedDemoManager.graphics.mousedown = tabbedDemoManager.onOpenPopup;
  tabbedDemoManager.show(false);

  messageBus.subscribe('common:ReadyToStart', function () {
    tabbedDemoManager.graphics.visible = true;

    const wasQueueForceAppliedOnClose = tabbedDemoManager.queueForceAppliedOnClose;
    tabbedDemoManager.queueForceAppliedOnClose = false;

    if (tabbedDemoManager.forceQueue.length > 0) {
      const nextForce = tabbedDemoManager.forceQueue.shift();
      gdk.gameForces(nextForce);
      // If persist is ON, re-add to end of queue to loop
      if (tabbedDemoManager.persistForce) {
        tabbedDemoManager.forceQueue.push(nextForce);
      }
    } else if (!wasQueueForceAppliedOnClose && tabbedDemoManager.persistForce && tabbedDemoManager.persistedForceData) {
      gdk.gameForces(tabbedDemoManager.persistedForceData);
    }
  });

  messageBus.subscribe('common:GameCommitted', function () {
    tabbedDemoManager.graphics.visible = false;
    //tabbedDemoManager.show(false);
  });

  Reflex.registerEventHandler('resize', tabbedDemoManager.onResize);
  Reflex.registerEventHandler('ready', tabbedDemoManager.onResize);

  var parentID = tabbedDemoManager.graphics.parent.Props.ID;
  if (resourceManager.hasContainer(parentID)) {
    resourceManager.getContainer(parentID).visible = true;
  } else {
    console.warn('tabbedDemoManager must be in the root of a container');
  }
};

tabbedDemoManager.enableButton = function (name, active) {
  if (checkForUndefined(active)) {
    active = true;
  }

  var button = tabbedDemoManager.buttons[name];
  if (checkForUndefined(button)) {
    console.log('Button ' + name + ' does not exist in tabbedDemoManager');
    return;
  }

  button.interactive = active;
  button.tint = active ? 0xffffff : 0x7f7f7f;
  tabbedDemoManager.redraw();
};

tabbedDemoManager.disableButton = function (name) {
  tabbedDemoManager.enableButton(name, false);
};

tabbedDemoManager.onResize = function () {
  tabbedDemoManager.redraw();
};

tabbedDemoManager.onOpenPopup = function () {
  tabbedDemoManager.show(true);

  messageBus.post('game:modal', {
    reason: 'Demo menu opened',
    data: 'tabbedDemoManager - open',
  });
};

tabbedDemoManager.getFilesRequired = function (json) {
  return [];
};

tabbedDemoManager.show = function (visible) {
  if (checkForUndefined(visible)) visible = true;

  tabbedDemoManager.showing = visible;
  tabbedDemoManager.closeButton.visible = visible;
  for (var i = 0; i < tabbedDemoManager.tabs.length; i++) {
    tabbedDemoManager.tabs[i].graphics.visible = visible;
    tabbedDemoManager.tabs[i].buttonContainer.visible = visible && i === tabbedDemoManager.currentTab;
    tabbedDemoManager.tabs[i].title.visible = visible;
  }
  tabbedDemoManager.demoButtonText.visible = !visible;
  tabbedDemoManager.graphics.interactive = !visible;
  tabbedDemoManager.redraw();
};

tabbedDemoManager.onClickedTab = function (object) {
  tabbedDemoManager.currentTab = object.target.tabindex;
  for (var i = 0; i < tabbedDemoManager.tabs.length; i++) {
    tabbedDemoManager.tabs[i].buttonContainer.visible = i === tabbedDemoManager.currentTab;
  }

  tabbedDemoManager.redraw();
};

tabbedDemoManager.createTab = function (name) {
  var index = tabbedDemoManager.tabs.length;

  var tab = {
    name: name,
    graphics: new PIXI.Graphics(),
    buttonContainer: resourceManager.createObject(
      'container',
      'buttonContainer' + tabbedDemoManager.tabs.length,
      tabbedDemoManager.graphics.name,
      {}
    ),
    buttons: [],
    title: new PIXI.Text(name, {
      fontFamily: 'Roboto-Black',
      fontSize: tabbedDemoManager.tabTextSize,
      fontWeight: 'bold',
      fill: 0x000000,
      align: 'center',
    }),
  };

  tab.graphics.tabindex = index;

  tabbedDemoManager.graphics.addChild(tab.graphics);
  //tabbedDemoManager.graphics.addChild(tab.buttonContainer);
  tab.graphics.addChild(tab.title);
  tab.graphics.interactive = true;
  tab.graphics.touchstart = tab.graphics.mousedown = tabbedDemoManager.onClickedTab;
  tab.title.anchor.set(0.5);
  tab.title.position.set(tabbedDemoManager.TAB_WIDTH * (index + 0.5), tabbedDemoManager.TAB_HEIGHT / 2);

  tabbedDemoManager.tabs.push(tab);

  return tab;
};

tabbedDemoManager.addToTab = function (index, item) {
  var name = item.name;
  var engine = gdk.getSupplierForceName();
  var tab = tabbedDemoManager.tabs[index];
  var column = tab.buttons.length % tabbedDemoManager.COLUMNS;
  var row = Math.floor(tab.buttons.length / tabbedDemoManager.COLUMNS);
  var offsetX = tabbedDemoManager.BUTTON_WIDTH + tabbedDemoManager.SPACING;
  var offsetY = tabbedDemoManager.BUTTON_HEIGHT + tabbedDemoManager.SPACING;
  var x = offsetX * column + tabbedDemoManager.BUTTON_WIDTH / 2 + tabbedDemoManager.SPACING;
  var y =
    tabbedDemoManager.TAB_HEIGHT + offsetY * row + tabbedDemoManager.BUTTON_HEIGHT / 2 + tabbedDemoManager.SPACING;

  var button = new PIXI.Graphics();
  var data = item[engine];
  if (!data) data = item.spins; // backwards compatibility
  if (!data) data = item.all; // replay stuff usually

  button.data = data;
  button.lineStyle(3, tabbedDemoManager.buttonHighlightColour, 1);
  button.beginFill(tabbedDemoManager.buttonColour);
  button.drawRect(
    x - tabbedDemoManager.BUTTON_WIDTH / 2,
    y - tabbedDemoManager.BUTTON_HEIGHT / 2,
    tabbedDemoManager.BUTTON_WIDTH,
    tabbedDemoManager.BUTTON_HEIGHT
  );
  button.endFill();
  button.lineStyle(3, tabbedDemoManager.buttonLowlightColour, 1);
  button.moveTo(x - tabbedDemoManager.BUTTON_WIDTH / 2, y + tabbedDemoManager.BUTTON_HEIGHT / 2);
  button.lineTo(x + tabbedDemoManager.BUTTON_WIDTH / 2, y + tabbedDemoManager.BUTTON_HEIGHT / 2);
  button.lineTo(x + tabbedDemoManager.BUTTON_WIDTH / 2, y - tabbedDemoManager.BUTTON_HEIGHT / 2);

  button.interactive = true;
  button.mousedown = button.touchstart = tabbedDemoManager.onButtonPressed;

  var buttonText = new PIXI.Text(name, {
    fontFamily: 'Roboto-Black',
    fontSize: tabbedDemoManager.buttonTextSize,
    fontWeight: 'bold',
    fill: 0xffffff,
    align: 'center',
    wordWrap: true,
    wordWrapWidth: tabbedDemoManager.BUTTON_WIDTH - 10,
  });
  buttonText.anchor.set(0.5);
  buttonText.position.set(x, y);
  button.addChild(buttonText);

  button.position.set();

  tabbedDemoManager.buttons[name] = button;
  tab.buttons.push(button);
  tab.buttonContainer.addChild(button);

  // "+" button for queue
  var plusButton = new PIXI.Graphics();
  var plusSize = 25;
  var plusX = x + tabbedDemoManager.BUTTON_WIDTH / 2 - plusSize / 2 - 5;
  var plusY = y - tabbedDemoManager.BUTTON_HEIGHT / 2 + plusSize / 2 + 5;

  plusButton.beginFill(0x00aa00);
  plusButton.drawRect(-plusSize / 2, -plusSize / 2, plusSize, plusSize);
  plusButton.endFill();
  plusButton.position.set(plusX, plusY);
  plusButton.interactive = true;
  plusButton.data = data;
  plusButton.buttonMode = true;

  var plusText = new PIXI.Text('+', {
    fontFamily: 'Roboto-Black',
    fontSize: 18,
    fill: 0xffffff,
    fontWeight: 'bold',
  });
  plusText.anchor.set(0.5);
  plusButton.addChild(plusText);

  plusButton.mousedown = plusButton.touchstart = tabbedDemoManager.onAddToQueue;
  tab.buttonContainer.addChild(plusButton);
  tabbedDemoManager.queueButtons.push(plusButton);

  var height = tabbedDemoManager.TAB_HEIGHT + (row + 1) * offsetY + tabbedDemoManager.SPACING + 50;
  if (height > tabbedDemoManager.popupHeight) {
    tabbedDemoManager.popupHeight = height;
  }
};

tabbedDemoManager.onButtonPressed = function () {
  const forceData = JSON.parse(JSON.stringify(this.data));
  gdk.gameForces(forceData);

  if (tabbedDemoManager.persistForce) {
    tabbedDemoManager.persistedForceData = forceData;
  } else {
    tabbedDemoManager.persistedForceData = null;
  }

  tabbedDemoManager.close();
};

tabbedDemoManager.close = function () {
  if (tabbedDemoManager.inputText) tabbedDemoManager.inputText.textInput.text = '';
  messageBus.post('game:modal', { data: 'tabbedDemoManager - close' });

  // Apply first queued force immediately when closing (if queue has items)
  if (tabbedDemoManager.forceQueue.length > 0) {
    const nextForce = tabbedDemoManager.forceQueue.shift();
    gdk.gameForces(nextForce);
    // If persist is ON, re-add to end of queue to loop
    if (tabbedDemoManager.persistForce) {
      tabbedDemoManager.forceQueue.push(nextForce);
    }
    tabbedDemoManager.queueForceAppliedOnClose = true;
  }

  tabbedDemoManager.show(false);
};

tabbedDemoManager.onPersistToggle = function () {
  tabbedDemoManager.persistForce = !tabbedDemoManager.persistForce;
  if (!tabbedDemoManager.persistForce) {
    tabbedDemoManager.persistedForceData = null;
    gdk.gameForces(null);
  }
  tabbedDemoManager.redraw();
};

tabbedDemoManager.onOverideStakeToggle = function () {
  tabbedDemoManager.overrideStake = !tabbedDemoManager.overrideStake;
  tabbedDemoManager.redraw();
};

tabbedDemoManager.onAddToQueue = function (event) {
  if (event && event.stopPropagation) {
    event.stopPropagation();
  }
  const forceData = JSON.parse(JSON.stringify(this.data));
  tabbedDemoManager.forceQueue.push(forceData);
  tabbedDemoManager.redraw();
};

tabbedDemoManager.clearQueue = function () {
  tabbedDemoManager.forceQueue = [];
  gdk.gameForces(null);
  tabbedDemoManager.redraw();
};

tabbedDemoManager.redraw = function () {
  var x, y, w, h;
  tabbedDemoManager.graphics.clear();

  if (!tabbedDemoManager.showing) {
    tabbedDemoManager.graphics.clear();
    tabbedDemoManager.graphics.lineStyle(3, 0, 1);
    tabbedDemoManager.graphics.beginFill(0xff0000, 0.7);
    tabbedDemoManager.graphics.drawPolygon([
      0,
      0,
      tabbedDemoManager.TRI_WIDTH,
      0,
      0,
      tabbedDemoManager.TRI_HEIGHT,
      0,
      0,
    ]);
    tabbedDemoManager.graphics.endFill();

    tabbedDemoManager.graphics.position.set(0, 0);

    // Hide UI elements when popup is closed
    if (tabbedDemoManager.persistCheckbox) {
      tabbedDemoManager.persistCheckbox.visible = false;
    }
    if (tabbedDemoManager.persistLabel) {
      tabbedDemoManager.persistLabel.visible = false;
    }
    if (tabbedDemoManager.queueCountText) {
      tabbedDemoManager.queueCountText.visible = false;
    }
    if (tabbedDemoManager.clearQueueButton) {
      tabbedDemoManager.clearQueueButton.visible = false;
    }
    if (tabbedDemoManager.clearQueueLabel) {
      tabbedDemoManager.clearQueueLabel.visible = false;
    }
    if (tabbedDemoManager.applyButton) {
      tabbedDemoManager.applyButton.visible = false;
    }
    if (tabbedDemoManager.applyLabel) {
      tabbedDemoManager.applyLabel.visible = false;
    }
    if (tabbedDemoManager.stakeOverideCheckbox) {
      tabbedDemoManager.stakeOverideCheckbox.visible = false;
    }
    if (tabbedDemoManager.stakeOverideLabel) {
      tabbedDemoManager.stakeOverideLabel.visible = false;
    }
    return;
  }

  // Draw main sheet
  w = tabbedDemoManager.popupWidth;
  h = tabbedDemoManager.popupHeight - tabbedDemoManager.TAB_HEIGHT;
  x = 0;
  y = tabbedDemoManager.TAB_HEIGHT;

  // Darken rest of screen
  tabbedDemoManager.graphics.beginFill(0, 0.7);
  tabbedDemoManager.graphics.drawRect(-5000, -5000, 10000, 10000);
  tabbedDemoManager.graphics.endFill();

  // Set position of popup to center of screen
  var sw =
    tabbedDemoManager.popupWidth *
    tabbedDemoManager.graphics.scale.x *
    resourceManager.selectedAssetResolution.scaleFactor;
  var sh =
    (tabbedDemoManager.popupHeight - tabbedDemoManager.TAB_HEIGHT) *
    tabbedDemoManager.graphics.scale.y *
    resourceManager.selectedAssetResolution.scaleFactor;
  tabbedDemoManager.graphics.position.set((Reflex.logicalScreenWidth - sw) / 2, (Reflex.logicalScreenHeight - sh) / 2);

  tabbedDemoManager.graphics.beginFill(tabbedDemoManager.buttonBackgroundColour, 1);
  tabbedDemoManager.graphics.drawRect(x, y, w, h);
  tabbedDemoManager.graphics.endFill();

  tabbedDemoManager.graphics.lineStyle(3, 0x777777, 1);
  tabbedDemoManager.graphics.moveTo(x, y);
  tabbedDemoManager.graphics.lineTo(x, y + h);
  tabbedDemoManager.graphics.lineTo(x + w, y + h);
  tabbedDemoManager.graphics.lineTo(x + w, y);

  // Draw close button
  tabbedDemoManager.closeButton.clear();
  x = w - tabbedDemoManager.TAB_HEIGHT;
  y = 0;

  if (tabbedDemoManager.tabTopWidth > tabbedDemoManager.buttonBackWidth) {
    var w = tabbedDemoManager.tabTopWidth - tabbedDemoManager.buttonBackWidth;
    tabbedDemoManager.closeButton.lineStyle(3, 0x777777, 1);
    tabbedDemoManager.closeButton.moveTo(x, y + tabbedDemoManager.TAB_HEIGHT);
    tabbedDemoManager.closeButton.lineTo(x - w, y + tabbedDemoManager.TAB_HEIGHT);
  }

  tabbedDemoManager.closeButton.beginFill(0xff0000, 1.0);
  tabbedDemoManager.closeButton.drawRect(x, y, tabbedDemoManager.TAB_HEIGHT, tabbedDemoManager.TAB_HEIGHT);
  tabbedDemoManager.closeButton.endFill();
  tabbedDemoManager.closeButton.lineStyle(3, 0x000000, 1);
  tabbedDemoManager.closeButton.moveTo(x, y);
  tabbedDemoManager.closeButton.lineTo(x + tabbedDemoManager.TAB_HEIGHT, y + tabbedDemoManager.TAB_HEIGHT);
  tabbedDemoManager.closeButton.moveTo(x, y + tabbedDemoManager.TAB_HEIGHT);
  tabbedDemoManager.closeButton.lineTo(x + tabbedDemoManager.TAB_HEIGHT, y);
  tabbedDemoManager.closeButton.lineStyle(3, 0x999999, 1);
  tabbedDemoManager.closeButton.beginFill(0x000000, 0.0);
  tabbedDemoManager.closeButton.drawRect(x, y, tabbedDemoManager.TAB_HEIGHT, tabbedDemoManager.TAB_HEIGHT);
  tabbedDemoManager.closeButton.endFill();

  // Draw all tabs
  for (var i = 0; i < tabbedDemoManager.tabs.length; i++) {
    var isActive = i === tabbedDemoManager.currentTab;
    x = i * tabbedDemoManager.TAB_WIDTH;
    y = 0;

    //tabbedDemoManager.tabs[i].title.tint = isActive ? 0xFFFFFF : 0x777777;

    tabbedDemoManager.graphics.lineStyle(0, 0x777777, 1);
    tabbedDemoManager.graphics.beginFill(
      isActive ? tabbedDemoManager.activeTabColour : tabbedDemoManager.inactiveTabColour,
      1.0
    );
    tabbedDemoManager.graphics.drawPolygon([
      x,
      y + tabbedDemoManager.TAB_HEIGHT,
      x + tabbedDemoManager.TAB_HEIGHT,
      y,
      x + tabbedDemoManager.TAB_WIDTH - tabbedDemoManager.TAB_HEIGHT,
      y,
      x + tabbedDemoManager.TAB_WIDTH,
      y + tabbedDemoManager.TAB_HEIGHT,
      x,
      y + tabbedDemoManager.TAB_HEIGHT,
    ]);
    tabbedDemoManager.graphics.endFill();

    tabbedDemoManager.tabs[i].graphics.clear();
    tabbedDemoManager.tabs[i].graphics.beginFill(0xffffff, 0.0);
    tabbedDemoManager.tabs[i].graphics.drawPolygon([
      x,
      y + tabbedDemoManager.TAB_HEIGHT,
      x + tabbedDemoManager.TAB_HEIGHT,
      y,
      x + tabbedDemoManager.TAB_WIDTH - tabbedDemoManager.TAB_HEIGHT,
      y,
      x + tabbedDemoManager.TAB_WIDTH,
      y + tabbedDemoManager.TAB_HEIGHT,
      x,
      y + tabbedDemoManager.TAB_HEIGHT,
    ]);
    tabbedDemoManager.tabs[i].graphics.endFill();

    tabbedDemoManager.graphics.lineStyle(3, 0x999999, 1);
    tabbedDemoManager.graphics.moveTo(x, y + tabbedDemoManager.TAB_HEIGHT);
    tabbedDemoManager.graphics.lineTo(x + tabbedDemoManager.TAB_HEIGHT, y);
    tabbedDemoManager.graphics.lineTo(x + tabbedDemoManager.TAB_WIDTH - tabbedDemoManager.TAB_HEIGHT, y);
    tabbedDemoManager.graphics.lineTo(x + tabbedDemoManager.TAB_WIDTH, y + tabbedDemoManager.TAB_HEIGHT);
  }

  // Persist checkbox
  if (tabbedDemoManager.persistCheckbox) {
    var checkboxSize = 24;
    var checkboxX = tabbedDemoManager.SPACING;
    var checkboxY = tabbedDemoManager.popupHeight - checkboxSize - tabbedDemoManager.SPACING;

    tabbedDemoManager.persistCheckbox.clear();
    tabbedDemoManager.persistCheckbox.visible = tabbedDemoManager.showing;

    if (tabbedDemoManager.showing) {
      tabbedDemoManager.persistCheckbox.lineStyle(2, 0xffffff, 1);
      tabbedDemoManager.persistCheckbox.beginFill(tabbedDemoManager.persistForce ? 0x00aa00 : 0x333333, 1);
      tabbedDemoManager.persistCheckbox.drawRect(checkboxX, checkboxY, checkboxSize, checkboxSize);
      tabbedDemoManager.persistCheckbox.endFill();

      // Tick if checked
      if (tabbedDemoManager.persistForce) {
        tabbedDemoManager.persistCheckbox.lineStyle(3, 0xffffff, 1);
        tabbedDemoManager.persistCheckbox.moveTo(checkboxX + 5, checkboxY + 12);
        tabbedDemoManager.persistCheckbox.lineTo(checkboxX + 10, checkboxY + 18);
        tabbedDemoManager.persistCheckbox.lineTo(checkboxX + 19, checkboxY + 6);
      }

      tabbedDemoManager.persistLabel.position.set(checkboxX + checkboxSize + 10, checkboxY + 2);
      tabbedDemoManager.persistLabel.visible = true;

      // Queue count and clear button
      if (tabbedDemoManager.queueCountText) {
        const queueCount = tabbedDemoManager.forceQueue.length;
        tabbedDemoManager.queueCountText.text = 'Queue: ' + queueCount;
        tabbedDemoManager.queueCountText.visible = true;

        const queueTextWidth = tabbedDemoManager.queueCountText.width;
        const centreX = tabbedDemoManager.popupWidth / 2;
        tabbedDemoManager.queueCountText.position.set(centreX - queueTextWidth / 2, checkboxY + 2);

        tabbedDemoManager.clearQueueButton.clear();
        tabbedDemoManager.clearQueueButton.visible = queueCount > 0;
        tabbedDemoManager.clearQueueLabel.visible = queueCount > 0;

        if (queueCount > 0) {
          const clearX = centreX + queueTextWidth / 2 + 10;
          var clearWidth = 60;
          var clearHeight = 24;
          tabbedDemoManager.clearQueueButton.beginFill(0xaa0000);
          tabbedDemoManager.clearQueueButton.drawRect(clearX, checkboxY, clearWidth, clearHeight);
          tabbedDemoManager.clearQueueButton.endFill();
          tabbedDemoManager.clearQueueLabel.position.set(clearX + clearWidth / 2, checkboxY + clearHeight / 2);
        }
      }

      // Apply button
      if (tabbedDemoManager.applyButton) {
        var applyWidth = tabbedDemoManager.applyLabel.width + 20;
        var applyHeight = tabbedDemoManager.applyLabel.height + 8;
        var applyX = tabbedDemoManager.popupWidth - applyWidth - tabbedDemoManager.SPACING;

        tabbedDemoManager.applyButton.clear();
        tabbedDemoManager.applyButton.visible = true;
        tabbedDemoManager.applyButton.beginFill(0x0077cc);
        tabbedDemoManager.applyButton.drawRect(applyX, checkboxY, applyWidth, applyHeight);
        tabbedDemoManager.applyButton.endFill();
        tabbedDemoManager.applyLabel.position.set(applyX + applyWidth / 2, checkboxY + applyHeight / 2);
        tabbedDemoManager.applyLabel.visible = true;
      }
    } else {
      tabbedDemoManager.persistLabel.visible = false;
      if (tabbedDemoManager.queueCountText) {
        tabbedDemoManager.queueCountText.visible = false;
      }
      if (tabbedDemoManager.clearQueueButton) {
        tabbedDemoManager.clearQueueButton.visible = false;
      }
      if (tabbedDemoManager.clearQueueLabel) {
        tabbedDemoManager.clearQueueLabel.visible = false;
      }
      if (tabbedDemoManager.applyButton) {
        tabbedDemoManager.applyButton.visible = false;
      }
      if (tabbedDemoManager.applyLabel) {
        tabbedDemoManager.applyLabel.visible = false;
      }
    }
  }

  // Persist checkbox
  if (tabbedDemoManager.stakeOverideCheckbox) {
    var checkboxSize = 24;
    var checkboxX = tabbedDemoManager.SPACING + 150;
    var checkboxY = tabbedDemoManager.popupHeight - checkboxSize - tabbedDemoManager.SPACING;

    tabbedDemoManager.stakeOverideCheckbox.clear();
    tabbedDemoManager.stakeOverideCheckbox.visible = tabbedDemoManager.showing;

    if (tabbedDemoManager.showing) {
      tabbedDemoManager.stakeOverideCheckbox.lineStyle(2, 0xffffff, 1);
      tabbedDemoManager.stakeOverideCheckbox.beginFill(tabbedDemoManager.persistForce ? 0x00aa00 : 0x333333, 1);
      tabbedDemoManager.stakeOverideCheckbox.drawRect(checkboxX, checkboxY, checkboxSize, checkboxSize);
      tabbedDemoManager.stakeOverideCheckbox.endFill();

      // Tick if checked
      if (tabbedDemoManager.overrideStake) {
        tabbedDemoManager.stakeOverideCheckbox.lineStyle(3, 0xffffff, 1);
        tabbedDemoManager.stakeOverideCheckbox.moveTo(checkboxX + 5, checkboxY + 12);
        tabbedDemoManager.stakeOverideCheckbox.lineTo(checkboxX + 10, checkboxY + 18);
        tabbedDemoManager.stakeOverideCheckbox.lineTo(checkboxX + 19, checkboxY + 6);
      }

      tabbedDemoManager.stakeOverideLabel.position.set(checkboxX + checkboxSize + 10, checkboxY + 2);
      tabbedDemoManager.stakeOverideLabel.visible = true;
    }
  }
};

resourceManager.registerObjectType(
  'tabbedDemoManager',
  tabbedDemoManager.create,
  tabbedDemoManager.initialise,
  tabbedDemoManager.getFilesRequired
);
